import { render, staticRenderFns } from "./EditLinkSimple.vue?vue&type=template&id=dc9d44b4&scoped=true"
import script from "./EditLinkSimple.vue?vue&type=script&lang=js"
export * from "./EditLinkSimple.vue?vue&type=script&lang=js"
import style0 from "./EditLinkSimple.vue?vue&type=style&index=0&id=dc9d44b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9d44b4",
  null
  
)

export default component.exports